module.exports = __webpack_public_path__ + "img/pnu_read_gallery2.742fb3d2.jpg";